
import { useQuery } from "@tanstack/react-query";
import { mockBlogPosts } from "@/data/mockBlogPosts";

export function useRelatedPosts(currentPostId: string) {
  const { data: posts = [], isLoading, error } = useQuery({
    queryKey: ['related-posts', currentPostId],
    queryFn: async () => {
      // In a real app, fetch from an API with proper related posts logic
      // return await fetch(`/api/blog-posts/related/${currentPostId}`).then(res => res.json());
      
      // For now, simulate related posts by returning up to 3 other posts
      await new Promise(resolve => setTimeout(resolve, 300));
      return mockBlogPosts
        .filter(post => post.id !== currentPostId)
        .slice(0, 3);
    },
  });
  
  return {
    posts,
    isLoading,
    error,
  };
}
